import { getItem, removeItem, setItem } from '@/helpers/storage';
import { getBrandConfig, clientMessages } from '@/api/backoffice';
import router from '@/router';

export const flags = {
  isAlreadySeenMobileAppLink: 'isAlreadySeenMobileAppLink',
};

function initFlags() {
  return Object.entries(flags).reduce((acc, [, value]) => {
    acc[value] = getItem(value) ?? false;
    return acc;
  }, {});
}

export const actionTypes = {
  loadBrandConfig: '[config] load brand config',
  fetchClientMessages: '[config] fetch client messages',
  initializeToken: '[config] initialize token',
};

export const mutationTypes = {
  setConfig: '[config] set config',
  updateFlag: '[config] update flag',
  setMessages: '[config] set messages',
  setToken: '[config] set token',
};

export default {
  state: {
    token: null,
    brandName: '',
    isConfigLoaded: false,
    appStoreLink: null,
    googlePlayLink: null,
    portalLink: null,
    chatProvider: null,
    appName: '',
    messages: [],
    ...initFlags(),
  },
  actions: {
    async [actionTypes.loadBrandConfig]({ commit }) {
      try {
        const res = await getBrandConfig();
        commit(mutationTypes.setConfig, res.data.data);
      } catch (error) {
        console.error(error);
      }
    },

    async [actionTypes.fetchClientMessages]({ state, commit }) {
      if (!state.token) {
        return;
      }

      try {
        const response = await clientMessages(state.token);

        const message = response?.data?.message;
        const data = response?.data?.data;

        if (message && message.toLowerCase().includes('expired')) {
          removeItem('accessToken');
          removeItem('currentProfile');
          removeItem('savedPath');
          router.push('/');
          return;
        }

        commit(mutationTypes.setMessages, data);
      } catch (error) {
        console.error(error);
        removeItem('accessToken');
        removeItem('currentProfile');
        removeItem('savedPath');
        router.push('/');
      }
    },

    [actionTypes.initializeToken]({ commit }) {
      try {
        const token = getItem('accessToken');
        commit(mutationTypes.setToken, token);
      } catch (error) {
        console.error('Failed to load token:', error);
      }
    },
  },
  mutations: {
    [mutationTypes.setConfig](state, payload) {
      state.isConfigLoaded = true;
      state.brandName = payload?.brandName;
      state.appStoreLink = payload?.apps?.ios;
      state.googlePlayLink = payload?.apps?.android;
      state.portalLink = payload?.portalLink;
      state.appName = payload?.appName;
      state.chatProvider = payload?.chatProvider;
    },
    [mutationTypes.updateFlag](state, { flag, value }) {
      state[flag] = value;
      setItem(flag, value);
    },
    [mutationTypes.setMessages](state, messages) {
      state.messages = messages;
    },
    [mutationTypes.setToken](state, token) {
      state.token = token;
    },
  },
  getters: {
    token: (state) => {
      if (state.token) return state.token;
      try {
        return getItem('accessToken');
      } catch {
        return null;
      }
    },
  },
};
